import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ContentView from '@material-ui/icons/Person';

const ClientNameButton = ({
  currentpage, record, edit
}) => {
  const editButton = (fRecord, needFetch = false) => (
    <a
      href='#'
      onClick={(evt) => { evt.preventDefault(); edit(true, fRecord, needFetch)(); }}
      style={{
        maxWidth: '100%',
        fontSize: '12px',
        color: '#2c9bc3'
      }}
    >
      <ContentView style={{ width: '18px', height: '18px', color: '#2c9bc3' }} />
      {record.name}
    </a>
  );
  if (currentpage === 'clients') {
    return editButton(record);
  }
  if (record.hasClient) {
    record.name = record.fio;
    return editButton(record, true);
  }
  return record.fio;
};

ClientNameButton.defaultProps = {
  user: null,
  create: null
};

ClientNameButton.propTypes = {
  edit: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  className: PropTypes.string,
  currentpage: PropTypes.string.isRequired
};

const mapStateToProps = state => (
  {
    currentpage: state.sc.currentpage
  }
);


export default connect(mapStateToProps)(ClientNameButton);



// WEBPACK FOOTER //
// ./src/components/ClientNameButton.js